import ApplicationModel from "../../../shared/models/applications/api/ApplicationModel";
import AppliedApplicationTemplateModel from "../../../shared/models/templating/api/AppliedApplicationTemplateModel";
import { OnboardingFlowConfig } from "../config/onboardingFlows";
import { ApplicationModuleFieldLookup } from "../api/applicationModuleFields";
import { OnboardingAnswerValue } from "./onboardingFieldUtils";

export interface OnboardingResponseFieldTarget {
    title: string;
    href: string;
}

export const getOnboardingResponseFieldTargets = (
    flow: OnboardingFlowConfig,
    application: ApplicationModel,
    answers: Record<string, unknown>,
    templates: AppliedApplicationTemplateModel[]
): Record<string, OnboardingResponseFieldTarget[]> => {
    const lookup: ApplicationModuleFieldLookup = {};
    const targets: Record<string, OnboardingResponseFieldTarget[]> = {};
    templates.forEach(template => (template.templateForm?.templateFormSections || []).forEach(section => {
        (section.templateFormFields || []).forEach(field => {
            if (!field.associatedVariable) return;
            const saved = template.templateFormFieldValues?.find(value => value.templateFormFieldId === field.id);
            lookup[field.associatedVariable] = { ...field, currentValue: saved?.value };
            const params = new URLSearchParams({ sectionId: section.id, fieldId: field.id });
            const target = {
                title: field.title || field.label || field.associatedVariable,
                href: `/v/apps/${encodeURIComponent(application.id)}?${params.toString()}`
            };
            targets[field.associatedVariable] = [...(targets[field.associatedVariable] || []), target];
        });
    }));

    const result: Record<string, OnboardingResponseFieldTarget[]> = {};
    flow.steps.forEach(step => step.questions.forEach(question => {
        if (!question.saveEnabled || !question.getSaveInstructions
            || (question.responseOnly && question.id !== "voiceSelection")
            || answers[question.id] === undefined) return;
        try {
            const instructions = question.getSaveInstructions(answers[question.id] as OnboardingAnswerValue, {
                application, moduleFieldLookup: lookup, storedAnswers: answers
            });
            const uniqueTargets = new Map<string, OnboardingResponseFieldTarget>();
            instructions.filter(instruction => instruction.value != null && String(instruction.value).trim() !== "")
                .forEach(instruction => (targets[instruction.associatedVariable] || []).forEach(target => {
                    uniqueTargets.set(target.href, target);
                }));
            result[question.id] = Array.from(uniqueTargets.values());
        } catch (_) {
            // Older responses may not match the current question's value shape.
            // Keep their copy action available instead of blocking the modal.
        }
    }));
    return result;
};
